export default __webpack_public_path__ + "images/b142575b7f1d45eda33cc6834c86503b-dsrp_mobile.webp";